import { render, staticRenderFns } from "./point-history.vue?vue&type=template&id=ff8fe5c6&scoped=true"
import script from "./point-history.vue?vue&type=script&lang=js"
export * from "./point-history.vue?vue&type=script&lang=js"
import style0 from "./point-history.vue?vue&type=style&index=0&id=ff8fe5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8fe5c6",
  null
  
)

export default component.exports